import getFeatureFlagsQuery from './getFeatureFlagsQuery';

export const CommonAuthorizationService = {
  getFeatureFlagsQuery,
};
